import React, { useContext } from 'react';
import { MarkupContext } from '../../../contexts';
import ThresholdSlider from '../sliders/thresholdSlider';
import ResolutionSlider from '../sliders/resolutionSlider';
import MarkupsList from './markupsList';

const RightPart = () => {
  const { tab } = useContext(MarkupContext);
  return (
    <div className="summary-markup_reactions_content">
      {
        tab === 1 &&
        <div className="page-row">
          <div className="page-row_col">
            <ResolutionSlider />
            <ThresholdSlider />
          </div>
        </div>
      }
      { !tab && <MarkupsList />}
    </div>

  );
};

export default RightPart;
